(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PlanDeEstudiosDetailController', PlanDeEstudiosDetailController);

    PlanDeEstudiosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PlanDeEstudios'];

    function PlanDeEstudiosDetailController($scope, $rootScope, $stateParams, previousState, entity, PlanDeEstudios) {
        var vm = this;

        vm.planDeEstudios = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:planDeEstudiosUpdate', function(event, result) {
            vm.planDeEstudios = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
